import { Component } from '@angular/core';
import { AdminActionsDirective } from '@app/main/admin/directives/admin-actions.directive';
import { DialogService } from '@shared/services';
import { ModuleService } from '@shared/services/module.service';
import { AdminService } from '../../admin.service';

@Component({
    selector: 'app-admin-report-template',
    templateUrl: './admin-report-template.component.html',
    styleUrls: ['./admin-report-template.component.scss'],
    standalone: false
})
export class AdminReportTemplateComponent extends AdminActionsDirective {
    constructor(adminService: AdminService, dialogService: DialogService, moduleService: ModuleService) {
        super(adminService, dialogService, moduleService);
    }
}
